<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="col-12 bg-primary py-3  text-center" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="text-white" >
                <template #default>پروفایل   </template>
                </m-h5></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container-fluid p-0 " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row pb-5 p-0 m-0 text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-12 text-center" >
                <template #default>   <m-user-profile-1 v-bind='{...{"advanceDescription":true,"advanceDescriptionInputs":"[   {     \"name\": \"\u0627\u0633\u062a\u0627\u0646\",     \"placeholder\": \"\",     \"regex\": \"\",     \"required\": true,     \"type\": \"text\"   },   {     \"name\": \"\u0634\u0647\u0631\",     \"placeholder\": \"\",     \"regex\": \"\",     \"required\": true,     \"type\": \"text\"   },   {     \"name\": \"\u067e\u0627\u06cc\u0647 \u062a\u062d\u0635\u06cc\u0644\u06cc\",     \"placeholder\": \"\",     \"regex\": \"\",     \"required\": true,     \"type\": \"text\"   },   {     \"name\": \"\u0631\u0634\u062a\u0647 \u062a\u062d\u0635\u06cc\u0644\u06cc\",     \"placeholder\": \"\",     \"regex\": \"\",     \"required\": true,     \"type\": \"text\"   },   {     \"name\": \"\u062c\u0646\u0633\u06cc\u062a\",     \"placeholder\": \"\",     \"regex\": \"\",     \"required\": true,     \"type\": \"text\"   } ]","loadUserProfile":false},...{}}' :style='"border:1px solid #cfcfcf;\nborder-radius:15px"' class="bg-white m-2 p-4 profile-sec" ></m-user-profile-1></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mUserProfile1 from '@moeinmdn/miw-alpha-components/src/package/User/Profile/UserProfile1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH5,mUserProfile1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
